import { Field, FieldProps } from 'formik'
import { FC } from 'react'
import { HiddenCheckbox, Slider, ToggleWrapper } from './style'
import { StyleFormWrapper, StyleLabel } from '../style'

interface ToggleProps {
  onChange?: (value) => void
  name: string
  label?: string
  styleWrapper?: string
  disabled?: boolean
}

const Toggle: FC<ToggleProps> = ({
  name,
  onChange,
  styleWrapper,
  label,
  disabled = false,
}) => {
  const handleChange = ({ form, value }) => {
    onChange && onChange(value)
    form.setFieldValue(name, value)
  }
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <StyleFormWrapper styleWrapper={styleWrapper}>
          {!!label && <StyleLabel>{label}</StyleLabel>}
          <ToggleWrapper>
            <HiddenCheckbox
              type="checkbox"
              checked={!!field.value}
              onChange={() => {
                handleChange({
                  form,
                  value: !field?.value,
                })
              }}
              disabled={disabled}
            />
            <Slider checked={!!field.value} />
          </ToggleWrapper>
        </StyleFormWrapper>
      )}
    </Field>
  )
}

export default Toggle
